import TextContent from '@/components/HighlightMediaText/TextContent/TextContent';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';

import type { HighlightMediaTextProps } from './HighlightMediaTextFull';
import useStyles from './HighlightMediaTextFull.styles';

const InnerContent = ({
  isOnDark,
  isRightAligned,
  subhead,
  cta,
  features,
  isHeroMode,
  eyebrow,
  headline,
  ...props
}: HighlightMediaTextProps) => {
  const { classes } = useStyles({ isOnDark });

  return (
    <GridContainer2
      fixed
      gridProps={{
        className: classes.fullSectionHeader,
        style: { justifyContent: isRightAligned ? 'flex-end' : 'flex-start' },
      }}
    >
      <TextContent
        subhead={subhead}
        features={features}
        cta={cta}
        isHeroMode={isHeroMode}
        eyebrow={eyebrow}
        headline={headline}
        isOnDark={isOnDark}
        {...props}
      />
    </GridContainer2>
  );
};

export default InnerContent;
